import React, {useEffect, useState} from "react";
import Config from "../../service/Config/config";
import callWebService, {callTypes} from "../../../src/service/Networks/network.js";
import { Link } from "react-router-dom/cjs/react-router-dom.min.js";
import {fireEvent} from "../MoEngage";
import { moeAddEmail, moeAddFirstName, moeAddUniqueUserId } from "../../utils/moengage";
import { ACCOUNT_LIST_URL, CAR_LOAN_B2B_FLOW, DARWIN_ATTENDANCE, DEALER_LIST_URL, JOURNEY_END_URL, JOURNEY_URL, LOGOUT_URL, TOLL_ACCOUNT_LIST_URL, VALET_ACCOUNT_LIST, VALET_PROJECT_LIST, isNewLeadX } from "../../utils/redirection.js";

const Header = ({
                    title = null,
                    history
                }) => {
    const previousPageUrl = document.referrer;
    const currentUrl = window.location.href

    const [notification, setNotification] = useState([])
    const [roleId, setRoleId] = useState("")
    const [unreadNotification, setUnreadNotification] = useState(0)
    const [userId, setUserId] = useState(0)
    const [teams, setTeams] = useState([{}])
    const [versionMismatch, setVersionMismatch] = useState(false)
    const [activeMenu, setActiveMenu] = useState(null);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [isManager, setIsManager] = useState(false);
    const [attendanceTab, setAttendanceTab] = useState(false);
    const [fusionRedirectUrl, setFusionRedirectUrl] = useState("#")

    useEffect(() => {
        let userProfile = localStorage.getItem('user_profile')
        if (userProfile === null) {
            handleUserProfile()
        }

        setRoleId(parseInt(window.localStorage.role_id))
        setUserId(window.localStorage.user_id)
        let userDetails = JSON.parse(userProfile)
        const teamIds = userDetails?.teams.map(team => team.team_id);

        setIsManager(userDetails?.darwin_manager_check);
        setAttendanceTab(userDetails?.attendance_tab_flag)
        if(parseInt(userProfile?.fusion_login_preference) === 2){
            setFusionRedirectUrl("https://play.google.com/store/search?q=fusion%20park%2B&c=apps&hl=en")
        } else {
            setFusionRedirectUrl("https://fusion.parkplus.io/")
        }
        setTeams(teamIds);
        if (!window.localStorage.previous_url || window.location.pathname === '/dashboard' || window.location.pathname === '/home' || window.location.pathname === '/profile') {
            window.localStorage.previous_url = JSON.stringify({0: window.location.href})
        } else {
            var returnObj = JSON.parse(window.localStorage.previous_url);
            if (returnObj === undefined || returnObj === '' || returnObj === {}) {
                window.localStorage.previous_url = JSON.stringify({0: window.location.href})
                return false
            }
            let obj = {}
            let index = 0
            if (window.performance) {
                if (!performance.navigation.type == 1) {
                    Object.keys(returnObj).map((val, i) => {
                        if (returnObj[val] === currentUrl) {
                            delete returnObj[val]
                        } else {
                            obj[index] = returnObj[val]
                            index++
                        }
                    })
                    obj[Object.keys(obj).length] = currentUrl
                    window.localStorage.previous_url = JSON.stringify(obj)
                }
            }
        }

    }, [])

    const versionCheck = (target, version) => {
        if(!version){
            return false;
        }
        const versionParts = version.split('.').map(Number);

        const targetParts = target.split('.').map(Number);

        for (let i = 0; i < Math.max(versionParts.length, targetParts.length); i++) {
            const v = versionParts[i] || 0; // Use 0 if a part is missing
            const t = targetParts[i] || 0;

            if (v > t) return true;  // Version is greater
            if (v < t) return false; // Version is less
        }

        return true; // Versions are equal
    }
    const handleUserProfile = async () => {
        const base_url = process.env.REACT_APP_API_URL;
        const role_id = window.localStorage.role_id ?? localStorage.getItem("role_id") ;
        fireEvent('debugging_event', {
            page: window.location?.pathname,
            api_endpoint: `${Config?.getProfile}?source=leadx&roleId=${role_id}`,
            step: "api_request_start",
            type: 'api_call',
        });
        let res = await callWebService(callTypes.get, '',`${Config?.getProfile}?source=leadx&roleId=${role_id}`);
        let webView = window.localStorage.webview
        if(window.localStorage.token){
            const base_url = process.env.REACT_APP_API_URL;
            const role_id = window.localStorage.role_id ?? localStorage.getItem("role_id") ;
            res = await callWebService(callTypes.get,'',`${Config?.getProfile}?source=leadx&roleId=${role_id}`);
        }
        const {data} = res;
        if(parseInt(data?.response?.fusion_login_preference) === 2){
            setFusionRedirectUrl("https://play.google.com/store/search?q=fusion%20park%2B&c=apps&hl=en")
        } else {
            setFusionRedirectUrl("https://fusion.parkplus.io/")
        }
        if(data?.response?.version){
            if(webView !== undefined && webView == 'true') {
                const message = {
                    event_name: 'version_check',
                    page_name: 'header',
                }
                const nativeObject = window.ReactNativeWebView;
                if (window!== undefined && window.ReactNativeWebView !== undefined) {
                    nativeObject.postMessage(JSON.stringify(message));
                    const handleMessage = (event) => {
                        console.log(event)
                        const checkVersion = event.data;
                        if(checkVersion?.version && !versionCheck('3.0.0', checkVersion?.version)){
                            setVersionMismatch(true)
                        }
                    }

                    window.addEventListener('message', handleMessage);
                    return () => {
                        window.removeEventListener('message', handleMessage);
                    };
                }
            }
        }

        if(parseInt(data.response.status_code) === 401 || parseInt(data.response.status_code) === 500){
            fireEvent('debugging_event', {
                page: window.location?.pathname,
                api_endpoint: `${Config?.getProfile}?source=leadx&roleId=${role_id}`,
                step: "api_request_fail",
                type: 'api_call',
            });
            delete localStorage.clear()
            if(isNewLeadX()){
                window.location.href=LOGOUT_URL
            } else window.location.href="/"
            if(webView !== undefined && webView == 'true'){
                console.log("logout event fired")
                const message = {
                    event_name: 'logout_user',
                    page:"header.js profile"
                }
                const nativeObject = window.ReactNativeWebView;
                if (nativeObject !== undefined) {
                    nativeObject.postMessage(JSON.stringify(message));
                    window.addEventListener('message', () => {})
                }
            }
        }

        fireEvent('debugging_event', {
            page: window.location?.pathname,
            api_endpoint: `${Config?.getProfile}?source=leadx&roleId=${role_id}`,
            step: "api_request_success",
            type: 'api_call',
        });

        if (data.response.data) {
            localStorage.setItem("user_profile", JSON.stringify(data?.response?.data));
            moeAddFirstName(data?.response?.data?.name);
            moeAddEmail(data?.response?.data?.email);
            moeAddUniqueUserId(data?.response?.data?.id);
            // localStorage.setItem("role_id", JSON.stringify(data?.response?.data?.roles[0]?.pivot?.role_id));
            setRoleId(JSON.stringify(data?.response?.data?.roles[0]?.id))
            window.localStorage.reload_home = false;
            setIsManager(data?.response?.data?.darwin_manager_check);
            setAttendanceTab(data?.response?.data?.attendance_tab_flag);
        }
    }

    useEffect(() => {
        if (roleId === null) {
            let roleId = parseInt(window.localStorage.role_id)
            setRoleId(roleId)
        }
        // alert(roleId)
    }, [roleId])

    function openNav(v) {
        var elem = document.getElementById("mySidenav");
        elem.classList.toggle("show-side-bar");
        var elemIcon = document.getElementById("change_icon");
        elemIcon.classList.toggle("bi-x");
    }

    const handlePreviousUrl = (e) => {
        if ( !window.localStorage.previous_url ||  window.location.pathname === '/dashboard' || window.location.pathname === '/home' || window.location.pathname === '/profile') {
            window.localStorage.previous_url = JSON.stringify({0: window.location.href})
        } else {
            var returnObj = JSON.parse(window.localStorage.previous_url);
            if (returnObj === undefined || returnObj === '' || returnObj === {}) {
                window.localStorage.previous_url = JSON.stringify({0: window.location.href})
                return false
            }

            let url = returnObj[Object.keys(returnObj).length - 2]
            delete returnObj[Object.keys(returnObj).length - 1]
            window.location.href = url
            window.localStorage.previous_url = JSON.stringify(returnObj)
        }
    }

    const handleLogout = (e) => {
        e.preventDefault()
        let webView = window.localStorage.webview
        localStorage.clear();
        if(webView !== undefined && webView == 'true'){
            console.log("logout event fired")
            const message = {
                event_name: 'logout_user',
                page:"header.js logout"
            }
            const nativeObject = window.ReactNativeWebView;
            if (nativeObject !== undefined) {
                nativeObject.postMessage(JSON.stringify(message));
                window.addEventListener('message', () => {})
            }
        } else {
            if(isNewLeadX()){
                window.location.href=LOGOUT_URL
            } else window.location.href="/"
        }
    }


    const handleReadNotification = async (e) => {
        if (window.location.pathname === '/notification') {
            e.preventDefault()
        }
    }

    const reloadPage = (e) => {
        //console.log('eee ' + e);
        if (e === true) {
            window.location.reload();
        }
    }

    const handleRemoveActivePage = () => {
        window.localStorage.active_page = ''
    }

    useEffect(() => {
        let webView = localStorage.getItem('webview');
        if(webView !== undefined && webView == 'true') {
            const message = {
                event_name: 'screenshot_prevent',
                page_name: 'no',
            }
            const nativeObject = window.ReactNativeWebView;
            if (nativeObject !== undefined) {
                nativeObject.postMessage(JSON.stringify(message));
                window.addEventListener('message', () => {
                })
            }
        }
    }, []);

    useEffect(() => {
        let webView = localStorage.getItem('webview');
        if(webView !== undefined && webView == 'true') {
            const message = {
                event_name: 'version_check',
                page_name: 'header',
            }
            const handleMessage = (event) => {
                console.log("event", event)
                const checkVersion = event?.data;
                if(!window.localStorage.app_version){
                    window.localStorage.app_version = checkVersion?.version;
                }

                if(checkVersion?.version && !versionCheck('3.0.0', checkVersion?.version)){
                    setVersionMismatch(true)
                }
            }

            const nativeObject = window.ReactNativeWebView;
            if (window!== undefined && window.ReactNativeWebView !== undefined) {
                nativeObject.postMessage(JSON.stringify(message));
                window.addEventListener('message', handleMessage);
                return () => {
                    window.removeEventListener('message', handleMessage);
                };
            }
        }
    }, []);

    const handleActivePage = (page) => {
        localStorage.setItem('active_page', page)
    }

    const handleActivePageCheck = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
    };

    const handleActiveSubMenuCheck = (subMenu) => { 
    setActiveSubMenu(activeSubMenu === subMenu ? null : subMenu);
    };

    return (
        <>
            {versionMismatch &&
                <>
                    <div className="modal show" id="exampleModalCenter" tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Alert!</h5>
                                </div>
                                <div className="modal-body">
                                    <p>New Version of Leadx is available. Please update!</p>
                                    <button onClick={(e) => {handleLogout(e)}}
                                            className="btn btn-primary mt-2 text-center"
                                    >
                                        Ok
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <nav className="navbar navbar-expand navbar-light bg-gradient-custom topbar pos-sticky static-top shadow">
                {title != null && title !== "" ? (
                        <>
                            <a className="btn btn-link d-md-none rounded-circle icn-white shadow-none"
                               onClick={(e) => handlePreviousUrl(e)}>
                                <i className="bi bi-chevron-left l-10"></i>
                            </a>
                            <span className="nav-title">{title}</span>
                        </>
                    ) :
                    <>
                        <button onClick={() => openNav(true)}
                                className="btn btn-link d-md-none rounded-circle mr-3 icn-white shadow-none">
                            <i id="change_icon" className="fa fa-bars"></i>
                        </button>
                    </>
                }
                {/* Mobile Side Bar */}
                <div id="mySidenav" className="sidenav">
                    <a href="/home"><i className="bi bi-house"></i>&nbsp;&nbsp;Home</a>
                    <a href={`${fusionRedirectUrl}`} target="_blank"><i className="fas fa-external-link-alt"></i>
                        &nbsp;&nbsp;Fusion</a>

                    {(attendanceTab || isManager)  && (
                    <>
                    {/* attendance tab starts */}
                        <a
                    className={activeMenu === "attendance" ? "active" : ""}
                    onClick={() => handleActivePageCheck("attendance")}
                    >
                    <i className="fas fa-calendar-check"></i>
                    &nbsp;&nbsp;Attendance&nbsp;&nbsp;&nbsp;&nbsp;
                    <i
                        className={`bi ${
                        activeMenu === "attendance"
                            ? "bi-caret-up-fill"
                            : "bi-caret-down-fill"
                        }`}
                    ></i>
                    </a>
                    <div
                        className={`list-unstyled components ${
                            activeMenu === "attendance" ? "" : "d-none"
                        }`}
                    >
                        <>
                        <a
                        className={`bi bi-briefcase-fill ${
                            activeSubMenu === "outOfOffice" ? "active" : ""
                        }`}
                        href={isNewLeadX() ? DARWIN_ATTENDANCE : "/not-at-site-attendance"}
                        >
                        &nbsp;&nbsp;Check-in/out
                        </a>
                        <a
                            className={`bi bi-file-text-fill ${
                            activeMenu === "attendanceRecord" ? "active" : ""
                            }`}
                            href="/monthly-regularization"
                        >
                            &nbsp;&nbsp;Attendance Record
                        </a>
                        </>
                        { (isManager == true) && (
                        <>
                        <a
                            className={`bi bi-check-square-fill ${
                            activeMenu === "regularizationRequests" ? "active" : ""
                            }`}
                            href="/manager-requests-list"
                        >
                            &nbsp;&nbsp;Request List
                        </a>
                        <a
                            className={`bi bi-list-task ${
                            activeMenu === "regularizationRequestsLogs" ? "active" : ""
                            }`}
                            href="/request-list-logs"
                        >
                            &nbsp;&nbsp;Attendance Logs
                        </a>
                        </>
                        )}
                    </div>
                    {/* attendance tab ends */}
                    </>
                    )}
                
                    {/* rating tab starts */}
                    <a
                        className={activeMenu === "ratingTree" ? "active" : ""}
                        onClick={() => handleActivePageCheck("ratingTree")}
                    >
                    <i className="bi bi-star-fill"></i>
                        &nbsp;&nbsp;Rate&nbsp;&nbsp;&nbsp;&nbsp;
                        <i
                        className={`bi ${
                            activeMenu === "ratingTree"
                            ? "bi-caret-up-fill"
                            : "bi-caret-down-fill"
                        }`}
                    ></i>
                    </a>
                    <div
                        className={`list-unstyled components ${
                            activeMenu === "ratingTree" ? "" : "d-none"
                        }`}
                        >
                        {parseInt(roleId) !== 55 &&
                            parseInt(roleId) !== 65 &&
                            parseInt(roleId) !== 66 && (
                            <>
                                <a
                                className={`bi bi-file-earmark-fill ${
                                    activeSubMenu === "scorecard" ? "active" : ""
                                }`}
                                href="/sm-list"
                                >
                                &nbsp;&nbsp;Self Scorecard
                                </a>
                                <hr/>
                                <a
                                className={`bi bi-star-fill ${
                                    activeSubMenu === "rating" ? "active" : ""
                                }`}
                                href="/rm-details"
                                >
                                &nbsp;&nbsp;Rating
                                </a>
                            </>
                        )}
                        {(parseInt(roleId) === 55 ||
                        parseInt(roleId) === 65 ||
                        parseInt(roleId) === 66) && (
                        <a
                        className={`bi bi-star-fill ${
                            activeSubMenu === "rating" ? "active" : ""
                        }`}
                        href="/users-list"
                        >
                        &nbsp;&nbsp;Rating
                        </a>
                        )}
                    </div>
                    {/* rating tab ends */}

                    <a href="/dashboard"><i className="bi bi-speedometer2"></i>&nbsp;&nbsp;Dashboard</a>
                    {/*{(parseInt(roleId) === 5 || parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 16 || parseInt(roleId) === 4) &&*/}
                    {/*    <a href="/lead-List"><i className="bi bi-cursor"></i>&nbsp;&nbsp;Lead</a>*/}
                    {/*}*/}

                    {(parseInt(roleId) === 29 || parseInt(roleId) === 30 || parseInt(roleId) === 43 || parseInt(roleId) === 41 || parseInt(roleId) === 42 || parseInt(roleId) === 6 || parseInt(roleId) === 54 || parseInt(roleId) === 55
                            || parseInt(roleId) === 67) &&
                        <>
                            <a href="/get-journey"><i className="fas fa-building"></i>&nbsp;&nbsp;Journey Stats</a>
                            {window.localStorage.journey_state === undefined ?
                                <a href={isNewLeadX()? JOURNEY_URL + `?module_type=${localStorage.getItem("module_type")}`: "/journey"}><i className='fas fa-plane-departure'></i>&nbsp;&nbsp;Start
                                    Journey</a>
                                :
                                <a href={isNewLeadX()? JOURNEY_END_URL + `?module_type=${localStorage.getItem("module_type")}` : "/journey"}><i className='fas fa-plane-arrival'></i>&nbsp;&nbsp;End Journey</a>
                            }
                            {(parseInt(roleId) === 29 || parseInt(roleId) === 30 || parseInt(roleId) === 43 || parseInt(roleId) === 67) &&
                                <>
                                    <a href={isNewLeadX()? TOLL_ACCOUNT_LIST_URL :"/fast-tag-toll-list" }><i className="bi bi-person-fill"></i>&nbsp;&nbsp;Toll</a>
                                    <a href="/fast-tag-toll-list/is_approval"><i
                                        className='far fa-lightbulb'></i>&nbsp;&nbsp;Meeting Request Raised</a>
                                </>
                            }

                            {parseInt(roleId) === 29 &&
                                <>
                                    <a href={`/pjp-review`}><i className="fa fa-eye" aria-hidden="true"></i>
                                        &nbsp;&nbsp;PJP</a>
                                    {/*<a href={`/pjp-approved-list/${userId}`}><i className="fa fa-check" aria-hidden="true"></i>&nbsp;&nbsp;Scheduled PJP</a>*/}
                                    {/*<a href={`/pjp-pending-list/${userId}`}><i className='far fa-lightbulb'></i>&nbsp;&nbsp;Pending Approval PJP</a>*/}
                                    {/*<a href={`/pjp-rejected-list/${userId}`}><i className="fa fa-ban"*/}
                                    {/*                                            aria-hidden="true"></i>*/}
                                    {/*    &nbsp;&nbsp;Rejected PJP</a>*/}
                                </>
                            }

                            {(parseInt(roleId) === 67) &&
                                <>
                                    <a href={`/pjp-review`}><i className="fa fa-eye" aria-hidden="true"></i>
                                        &nbsp;&nbsp;PJP Approval</a>
                                    {/*<a href={`/pjp-pending-list/${userId}`}><i className='far fa-lightbulb'></i>&nbsp;&nbsp;Pending Approval PJP</a>*/}
                                    {/*<a href={`/pjp-rejected-list`}><i className="fa fa-ban"*/}
                                    {/*                                            aria-hidden="true"></i>*/}
                                    {/*    &nbsp;&nbsp;Rejected PJP</a>*/}
                                </>
                            }

                            {(parseInt(roleId) === 30 || parseInt(roleId) === 43) &&
                                <>
                                    <a href={`/pjp-submission`}><i className='far fa-lightbulb'></i>&nbsp;&nbsp;PJP
                                        Submission</a>
                                    <a href={`/pjp-review`}><i className="fa fa-eye" aria-hidden="true"></i>
                                        &nbsp;&nbsp;PJP Status</a>
                                    {/*<a href={`/pjp-rejected-list`}><i className="fa fa-ban" aria-hidden="true"></i>*/}
                                    {/*    &nbsp;&nbsp;Rejected PJP</a>*/}
                                </>
                            }

                        </>

                    }

                    {/*{(parseInt(roleId) === 41 || parseInt(roleId) === 42 || parseInt(roleId) === 6) && (*/}
                    {/*        <>*/}
                    {/*            window.localStorage.journey_state === undefined ?*/}
                    {/*            <a href="/Journey"><i className='fas fa-plane-departure'></i>&nbsp;&nbsp;Start Journey</a>*/}
                    {/*            :*/}
                    {/*            <a href="/Journey"><i className='fas fa-plane-arrival'></i>&nbsp;&nbsp;End Journey</a>*/}
                    {/*        </>*/}
                    {/*)*/}

                    {/*}*/}

{/* {console.log("EASDFYGUHJ",parseInt(roleId))}
                    {parseInt(roleId) == 79 && (
                        <Link href="/leads" className="d-flex align-items-center">
                            <i className="bi bi-person-fill"></i>&nbsp;&nbsp;Leads Management
                        </Link>
                    )} */}

                    {(parseInt(roleId) === 15 || parseInt(roleId) === 17 || parseInt(roleId) === 19 || parseInt(roleId) === 14 || parseInt(roleId) === 56) &&
                        <a href="/ba-account-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;BA Sites</a>
                    }

                    {(parseInt(roleId) === 35 || parseInt(roleId) === 36 || parseInt(roleId) === 37 || parseInt(roleId) === 38 || parseInt(roleId) === 48) &&
                        <>
                            <a href="/parking-account-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;Existing
                                Parking</a>
                            <a href="/new-parking-account-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;New
                                Parking</a>
                        </>
                    }

                    {roleId && (parseInt(roleId) !== 41 && parseInt(roleId) !== 42 && parseInt(roleId) !== 30 && parseInt(roleId) !== 29 && parseInt(roleId) !== 43)
                        && parseInt(roleId) !== 46 && parseInt(roleId) !== 47 && parseInt(roleId) !== 35 && parseInt(roleId) !== 37 && parseInt(roleId) !== 38 && parseInt(roleId) !== 48 &&
                        parseInt(roleId) !== 36 && parseInt(roleId) !== 15 && parseInt(roleId) !== 17 && parseInt(roleId) !== 19 && parseInt(roleId) !== 14 && parseInt(roleId) !== 54 &&
                        parseInt(roleId) !== 55 &&
                        <a href={isNewLeadX()? ACCOUNT_LIST_URL : "/list-account"}><i className="bi bi-person-fill"></i>&nbsp;&nbsp;Account</a>
                    }

                    {(parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 4 || parseInt(roleId) === 5) &&
                        <>
                            <a href="/car-service-account-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;Car
                                Service</a>
                        </>
                    }
                    {(parseInt(roleId) === 46 || parseInt(roleId) === 47 || parseInt(roleId) === 76) &&
                        <>
                            <a href={isNewLeadX()? VALET_ACCOUNT_LIST: "/valet_account-list"}><i className="bi bi-person-fill"></i>&nbsp;&nbsp;New Sites</a>
                            <a href={isNewLeadX()? VALET_PROJECT_LIST: "/valet-existing-sites"} ><i className="bi bi-person-fill"></i>&nbsp;&nbsp;Existing
                                Sites</a>
                            <a href="/external-mom-listing"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;External
                                Mom</a>
                        </>
                    }

                    {/* {(parseInt(roleId) === 35 || parseInt(roleId) === 36 || parseInt(roleId) === 37 || parseInt(roleId) === 38 || parseInt(roleId) === 48) &&
                    <>
                        <a href="/parking-account-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;Existing
                            Parking</a>
                        <a href="/new-parking-account-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;New Parking</a>
                        <a href="/external-mom-listing"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;External Mom</a>
                    </>
                } */}

                    {(parseInt(roleId) === 43 || parseInt(roleId) === 30 || parseInt(roleId) === 29) &&
                        <a href="/approved-pending-list"><i className="bi bi-cursor"></i>&nbsp;&nbsp;Approval
                            Pending</a>
                    }

                    {(parseInt(roleId) === 41 || parseInt(roleId) === 42 || parseInt(roleId) === 6 || parseInt(roleId) === 54 || parseInt(roleId) === 55) &&
                        <>
                            {teams && teams.includes(18) &&
                                <>
                                    <a href="/dealer-lead-list"><i className="bi bi-cursor"></i>&nbsp;&nbsp;NCD Lead</a>
                                    <a href={isNewLeadX()? DEALER_LIST_URL : "/dealer-list/ncd"}><i
                                        className="bi bi-person-fill"></i>&nbsp;&nbsp;Ncd  Dealer</a>
                                </>
                            }

                            {(parseInt(roleId) === 41 || parseInt(roleId) === 42) &&
                                <a href="/task-list/2"><i className="fas fa-tasks"></i>&nbsp;&nbsp;Assigned Task</a>
                            }

                            {parseInt(roleId) === 42 &&
                                <a href="/dsm-lead-pending"><i className="fas fa-tasks"></i>&nbsp;&nbsp;Lead Request</a>
                            }

                            {parseInt(roleId) === 55 &&
                                <a href="/dsm-lead-address-approval-list"><i
                                    className="fas fa-tasks"></i>&nbsp;&nbsp;Location Request</a>
                            }


                            {teams && teams.includes(28) &&
                            <>
                                {/* ucd dealer tab starts */}
                                <a
                                    className={activeMenu === "ucdDealer" ? "active" : ""}
                                    onClick={() => handleActivePageCheck("ucdDealer")}
                                >
                                    <i className="fas fa-building"></i>
                                    &nbsp;&nbsp;UCD Dealer&nbsp;&nbsp;&nbsp;&nbsp;
                                    <i
                                    className={`bi ${
                                        activeMenu === "ucdDealer"
                                        ? "bi-caret-up-fill"
                                        : "bi-caret-down-fill"
                                    }`}
                                    ></i>
                                </a>
                                {(parseInt(roleId) === 41 ||
                                parseInt(roleId) === 54) && (
                                <>
                                    <li className="">
                                    <a
                                        href={`${CAR_LOAN_B2B_FLOW}?roleId=${roleId}&auth_token=${window.localStorage.getItem(
                                        "token"
                                        )}&refresh_token=${window.localStorage.getItem(
                                        "refresh_token"
                                        )}&source=parkplus_leadx_webview`}
                                    >
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                        &nbsp;&nbsp;Check PA offer
                                    </a>
                                    </li>
                                </>
                                )}
                                <div
                                    className={`list-unstyled components ${
                                        activeMenu === "ucdDealer" ? "" : "d-none"
                                    }`}
                                    >
                                    <a
                                    className={`bi bi-clock-fill ${
                                        activeSubMenu === "pendingList" ? "active" : ""
                                    }`}
                                    href="/ucd-dealer-list"
                                    >
                                    &nbsp;&nbsp;Pending Dealer
                                    </a>
                                    <hr/>
                                    <a
                                    className={`bi bi-check-circle-fill ${
                                        activeSubMenu === "approvedList" ? "active" : ""
                                    }`}
                                    href="/ucd-approval-list"
                                    >
                                    &nbsp;&nbsp;Verified Dealer
                                    </a>
                                    <a
                                    className={`bi bi-x-circle-fill ${
                                        activeSubMenu === "approvedList" ? "active" : ""
                                    }`}
                                    href="/ucd-unverified-list"
                                    >
                                    &nbsp;&nbsp;Un-verified Dealer
                                    </a>
                                </div>
                                {/*ucd dealer   tab ends */}

                                <a href="/ucd-lead-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;UCD Lead</a>
                                {parseInt(roleId) === 54 &&
                                    <a href="/ucd-lead-pending-list"><i
                                        className="bi bi-person-fill"></i>&nbsp;&nbsp;Lead Approval</a>
                                }
                                {/* <a href="/ucd-dealer-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;UCD
                                    Dealer</a> */}

                                {/* <a href="/ucd-lead-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;UCD Lead</a>
                                {parseInt(roleId) === 54 &&
                                    <a href="/ucd-lead-pending-list"><i
                                        className="bi bi-person-fill"></i>&nbsp;&nbsp;Lead Approval</a>
                                }
                                <a href="/ucd-dealer-list"><i className="bi bi-person-fill"></i>&nbsp;&nbsp;UCD
                                    Dealer</a> */}
                                { (parseInt(roleId) === 54 || parseInt(roleId) === 55) && 
                                    <a href="/ucd-change-assignee"><i className="bi bi-arrow-left-right"></i>&nbsp;&nbsp;Transfer Assignee</a>
                                }
                            </>
                            }
                        </>
                    }

                    {(parseInt(roleId) === 5 || parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 16 || parseInt(roleId) === 4 || parseInt(roleId) === 15 || parseInt(roleId) === 17 || parseInt(roleId) === 41) &&
                        <>
                            <a href="/task-list/1"><i className="bi bi-card-checklist"></i>&nbsp;&nbsp;Create Task</a>
                            <a href="/task-list/2"><i className="fas fa-tasks"></i>&nbsp;&nbsp;Assigned Task</a>
                            <a href="/heatmap" onClick={() => {
                                handleActivePage("heatMap")
                            }}><i className="fa fa-bolt"></i>&nbsp;&nbsp;Park+ Heatmap</a>
                        </>
                    }

                    {parseInt(roleId) === 42 &&
                        <a href="/task-list/1"><i className="bi bi-card-checklist"></i>&nbsp;&nbsp;Create Task</a>
                    }
                    {(parseInt(roleId) !== 41 && parseInt(roleId) !== 42 && parseInt(roleId) !== 54 && parseInt(roleId) !== 55) &&
                        <a href="/assignment"><i className="fas fa-handshake"></i>&nbsp;&nbsp;Change Assignee</a>
                    }

                {/* ticket tab starts */}
                <a
                    className={activeMenu === "ticket" ? "active" : ""}
                    onClick={() => handleActivePageCheck("ticket")}
                >
                    <i className="fas fa-ticket-alt"></i>
                    &nbsp;&nbsp;Ticket&nbsp;&nbsp;&nbsp;&nbsp;
                    <i
                    className={`bi ${
                        activeMenu === "ticket"
                        ? "bi-caret-up-fill"
                        : "bi-caret-down-fill"
                    }`}
                    ></i>
                </a>
                <div
                    className={`list-unstyled components ${
                        activeMenu === "ticket" ? "" : "d-none"
                    }`}
                    >
                    <a
                    className={`bi bi-patch-question-fill ${
                        activeSubMenu === "raiseIssue" ? "active" : ""
                    }`}
                    href="/raise-issue"
                    >
                    &nbsp;&nbsp;Raise Issue
                    </a>
                    <hr/>
                    <a
                    className={`bi bi-list-check ${
                        activeSubMenu === "ticketList" ? "active" : ""
                    }`}
                    href="/ticket-details"
                    >
                    &nbsp;&nbsp;Ticket List
                    </a>
                </div>
                {/*ticket   tab ends */}
                
                    <a href="/tagged-along-activity"><i className="fas fa-handshake"></i>&nbsp;&nbsp;Tag Along Approvals</a>
                    <a href="/attendance-regularization-request"><i className="fa fa-bolt"></i>&nbsp;&nbsp;Attendance
                        Regularisation</a>
                    <a href="/referrals-options"><i className="fa fa-user-plus"></i>&nbsp;&nbsp;Referrals</a>

                    <a href="#" className="logout" onClick={(e) => {
                        handleLogout(e)
                    }}><i
                        className="fas fa-sign-out-alt"></i>&nbsp;&nbsp;Logout</a>
                </div>
                <ul className="navbar-nav ml-auto nav-alignment d-flex item-center mr-0">
                    <li className="nav-item dropdown no-arrow d-sm-none hide">
                        <a className="nav-link dropdown-toggle" href="src/component/layout/header#" id="searchDropdown"
                           role="button"
                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fas fa-search fa-fw"></i>
                        </a>

                        <div className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
                             aria-labelledby="searchDropdown">
                            <form className="form-inline mr-auto w-100 navbar-search">
                                <div className="input-group">
                                    <input type="text" className="form-control bg-light border-0 small"
                                           placeholder="Search for..." aria-label="Search"
                                           aria-describedby="basic-addon2"/>
                                    <div className="input-group-append">
                                        <button className="btn btn-primary" type="button">
                                            <i className="fas fa-search fa-sm"></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </li>

                    <li className="nav-item dropdown no-arrow">
                        <a className="nav-link" onClick={() => reloadPage(true)}>
                            <i className="bi bi-arrow-clockwise f-20px"></i>
                        </a>
                    </li>

                    <li className="nav-item dropdown no-arrow mx-1">
                        <a className="nav-link " href={`notification`}
                           aria-haspopup="true" aria-expanded="false" onClick={(e) => {
                            handleReadNotification(e)
                        }}>
                            <i className="fas fa-bell fa-fw"></i>

                            <span className="badge badge-danger badge-counter">{unreadNotification}+</span>
                        </a>

                        <div
                            className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                            aria-labelledby="alertsDropdown">
                            {/*<h6 className="dropdown-header">*/}
                            {/*    Alerts Center*/}
                            {/*</h6>*/}
                            {/*{notification.length > 0 && notification.map((val, i) => {*/}
                            {/*    return (*/}
                            {/*        <>*/}
                            {/*            <a className="dropdown-item d-flex align-items-center" href={val?.link} onClick={(e ) => {handleReadNotification(e, val?.id)}}>*/}
                            {/*                <div className="mr-3">*/}
                            {/*                    <div className="icon-circle bg-primary">*/}
                            {/*                        <i className="fas fa-file-alt text-white"></i>*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*                <div>*/}
                            {/*                    <div className="small text-gray-500">{Moment(val?.created_at).format('DD-MMMM-YYYY')}</div>*/}
                            {/*                    <span className="font-weight-bold">{val?.title}</span>*/}
                            {/*                </div>*/}
                            {/*            </a>*/}
                            {/*        </>*/}
                            {/*    )*/}
                            {/*})}*/}
                            {/*<a className="dropdown-item d-flex align-items-center" href="src/component/layout/header#">*/}
                            {/*    <div className="mr-3">*/}
                            {/*        <div className="icon-circle bg-primary">*/}
                            {/*            <i className="fas fa-file-alt text-white"></i>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div>*/}
                            {/*        <div className="small text-gray-500">December 12, 2019</div>*/}
                            {/*        <span className="font-weight-bold">A new monthly report is ready to download!</span>*/}
                            {/*    </div>*/}
                            {/*</a>*/}
                            {/*<a className="dropdown-item d-flex align-items-center" href="src/component/layout/header#">*/}
                            {/*    <div className="mr-3">*/}
                            {/*        <div className="icon-circle bg-success">*/}
                            {/*            <i className="fas fa-donate text-white"></i>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div>*/}
                            {/*        <div className="small text-gray-500">December 7, 2019</div>*/}
                            {/*        $290.29 has been deposited into your account!*/}
                            {/*    </div>*/}
                            {/*</a>*/}
                            {/*<a className="dropdown-item d-flex align-items-center" href="src/component/layout/header#">*/}
                            {/*    <div className="mr-3">*/}
                            {/*        <div className="icon-circle bg-warning">*/}
                            {/*            <i className="fas fa-exclamation-triangle text-white"></i>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div>*/}
                            {/*        <div className="small text-gray-500">December 2, 2019</div>*/}
                            {/*        Spending Alert: We've noticed unusually high spending for your account.*/}
                            {/*    </div>*/}
                            {/*</a>*/}
                            {/*<a className="dropdown-item text-center small text-gray-500" href="notification">Show All*/}
                            {/*    Alerts</a>*/}
                        </div>
                    </li>


                    {/* <li className="nav-item dropdown no-arrow mx-1">
                    <a className="nav-link dropdown-toggle" href="#" id="messagesDropdown" role="button"
                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fas fa-envelope fa-fw"></i>

                        <span className="badge badge-danger badge-counter">7</span>
                    </a>

                    <div
                        className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                        aria-labelledby="messagesDropdown">
                        <h6 className="dropdown-header">
                            Message Center
                        </h6>
                        <a className="dropdown-item d-flex align-items-center" href="#">
                            <div className="dropdown-list-image mr-3">
                                <img className="rounded-circle" src="img/undraw_profile_1.svg"
                                     alt="..." />
                                <div className="status-indicator bg-success"></div>
                            </div>
                            <div className="font-weight-bold">
                                <div className="text-truncate">Hi there! I am wondering if you can help
                                    me with a
                                    problem I've been having.
                                </div>
                                <div className="small text-gray-500">Emily Fowler · 58m</div>
                            </div>
                        </a>
                        <a className="dropdown-item d-flex align-items-center" href="#">
                            <div className="dropdown-list-image mr-3">
                                <img className="rounded-circle" src="img/undraw_profile_2.svg"
                                     alt="..." />
                                <div className="status-indicator"></div>
                            </div>
                            <div>
                                <div className="text-truncate">I have the photos that you ordered last
                                    month, how
                                    would you like them sent to you?
                                </div>
                                <div className="small text-gray-500">Jae Chun · 1d</div>
                            </div>
                        </a>
                        <a className="dropdown-item d-flex align-items-center" href="#">
                            <div className="dropdown-list-image mr-3">
                                <img className="rounded-circle" src="img/undraw_profile_3.svg"
                                     alt="..." />
                                <div className="status-indicator bg-warning"></div>
                            </div>
                            <div>
                                <div className="text-truncate">Last month's report looks great, I am
                                    very happy with
                                    the progress so far, keep up the good work!
                                </div>
                                <div className="small text-gray-500">Morgan Alvarez · 2d</div>
                            </div>
                        </a>
                        <a className="dropdown-item d-flex align-items-center" href="#">
                            <div className="dropdown-list-image mr-3">
                                <img className="rounded-circle"
                                     src="https://source.unsplash.com/Mv9hjnEUHR4/60x60"
                                     alt="..." />
                                <div className="status-indicator bg-success"></div>
                            </div>
                            <div>
                                <div className="text-truncate">Am I a good boy? The reason I ask is
                                    because someone
                                    told me that people say this to all dogs, even if they aren't
                                    good...
                                </div>
                                <div className="small text-gray-500">Chicken the Dog · 2w</div>
                            </div>
                        </a>
                        <a className="dropdown-item text-center small text-gray-500" href="#">Read More
                            Messages</a>
                    </div>
                </li> */}

                    <div className="topbar-divider d-none d-sm-block"></div>


                    <li className="nav-item dropdown no-arrow">
                        <a className="nav-link" href="/profile" id="userDropdown" role="button" aria-haspopup="true"
                           aria-expanded="false" onClick={handleRemoveActivePage}>
                            <a className="mr-2 d-none d-lg-inline small un-cls">{localStorage.getItem('name')}</a>
                            <img className="img-profile rounded-circle"
                                 src="img/undraw_profile.svg" alt={""}/>
                        </a>

                        {/* <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                         aria-labelledby="userDropdown">
                        <a className="dropdown-item" href="/profile">
                            <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                            Profile
                        </a>
                        <a className="dropdown-item" href="src/component/layout/header#">
                            <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                            Settings
                        </a>
                        <a className="dropdown-item" href="src/component/layout/header#">
                            <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                            Activity Log
                        </a>
                        <div className="dropdown-divider"></div>
                        <a className="dropdown-item" href="src/component/layout/header#" data-toggle="modal"
                           data-target="#logoutModal">
                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                            Logout
                        </a>
                    </div> */}
                    </li>

                </ul>
            </nav>
            {/*<script id="moengage">*/}
            {/*    {`!(function(e,n,i,t,a,r,o,d){var s=e[a]=e[a]||[];if(s.invoked=0,s.initialised>0||s.invoked>0)return console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1;e.moengage_object=a;var l={},g=function n(i){return function(){for(var n=arguments.length,t=Array(n),a=0;a<n;a++)t[a]=arguments[a];(e.moengage_q=e.moengage_q||[]).push({f:i,a:t})}},u=["track_event","add_user_attribute","add_first_name","add_last_name","add_email","add_mobile","add_user_name","add_gender","add_birthday","destroy_session","add_unique_user_id","moe_events","call_web_push","track","location_type_attribute"],m={onsite:["getData","registerCallback"]};for(var c in u)l[u[c]]=g(u[c]);for(var v in m)for(var f in m[v])null==l[v]&&(l[v]={}),l[v][m[v][f]]=g(v+"."+m[v][f]);r=n.createElement(i),o=n.getElementsByTagName("head")[0],r.async=1,r.src=t,o.appendChild(r),e.moe=e.moe||function(){return(s.invoked=s.invoked+1,s.invoked>1)?(console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1):(d=arguments.length<=0?void 0:arguments[0],l)},r.addEventListener("load",function(){if(d)return e[a]=e.moe(d),e[a].initialised=e[a].initialised+1||1,!0}),r.addEventListener("error",function(){return console.error("Moengage Web SDK loading failed."),!1})}(window,document,"script","https://cdn.moengage.com/webpush/moe_webSdk.min.latest.js","Moengage"))*/}
            {/*  Moengage = moe({*/}
            {/*  app_id: '${process.env.MOENGAGE_APP_ID}',*/}
            {/*  debug_logs: '${process.env.MOENGAGE_DEBUG_LOGS}'*/}
            {/*  });`}*/}
            {/*</script>*/}
        </>
    );
};

export default Header;
